export function buildInitialValues(schema: any): Record<string, any> {
  const result: Record<string, any> = {};
  if (!schema?.properties) return result;

  // properties whose presence depends on an allOf if/then/else "required" clause
  const conditionalProps = new Set<string>();
  if (Array.isArray(schema.allOf)) {
    for (const condition of schema.allOf) {
      (condition.then?.required ?? []).forEach((key: string) => conditionalProps.add(key));
      (condition.else?.required ?? []).forEach((key: string) => conditionalProps.add(key));
    }
  }
  const baseRequired = new Set<string>(schema.required ?? []);

  for (const [key, def] of Object.entries<any>(schema.properties)) {
    // skip conditionally-required properties until we know whether the condition is met
    if (conditionalProps.has(key) && !baseRequired.has(key)) continue;
    setPropertyDefault(result, key, def);
  }

  if (Array.isArray(schema.allOf)) {
    for (const condition of schema.allOf) {
      if (!condition?.if) continue;
      const matches = evaluateIfCondition(condition.if, result);
      const activeRequired: string[] = (matches ? condition.then?.required : condition.else?.required) ?? [];
      for (const key of activeRequired) {
        const def = schema.properties[key];
        if (def) setPropertyDefault(result, key, def);
      }
    }
  }

  return result;
}

function setPropertyDefault(result: Record<string, any>, key: string, def: any) {
  if (def.type === 'array') result[key] = [];
  else if (def.type === 'string') result[key] = '';
  else if (def.type === 'boolean') result[key] = false;
  else if (def.type === 'object') result[key] = buildInitialValues(def);
}

function evaluateIfCondition(ifSchema: any, data: Record<string, any>): boolean {
  if (!ifSchema?.properties) return true;
  return Object.entries<any>(ifSchema.properties).every(([key, subSchema]) => {
    const value = data[key];
    if ('const' in subSchema) return value === subSchema.const;
    if (Array.isArray(subSchema.enum)) return subSchema.enum.includes(value);
    return true;
  });
}
